interface StatCardProps {
  label: string;
  value: number | string;
  hint?: string;
  variant?: 'default' | 'teal' | 'orange' | 'purple';
}

const variantClasses = {
  default: 'text-white',
  teal: 'text-teal-400',
  orange: 'text-orange-400',
  purple: 'text-purple-400',
};

export function StatCard({
  label,
  value,
  hint,
  variant = 'default',
}: StatCardProps) {
  return (
    <div className="rounded-lg border border-neutral-800/60 px-4 py-3">
      <div
        className={`text-xl font-semibold tabular-nums ${variantClasses[variant]}`}
      >
        {value}
      </div>
      <div className="text-xs text-neutral-500 mt-0.5">{label}</div>
      {hint && (
        <div className="text-[11px] text-neutral-600 mt-0.5">{hint}</div>
      )}
    </div>
  );
}
